<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="16.581" height="16.585" viewBox="0 0 16.581 16.585">
		<g id="Group_43252" data-name="Group 43252" transform="translate(-61.221 -509.517)">
			<path
				id="Path_19917"
				data-name="Path 19917"
				d="M8.458,3.256H4.124a.867.867,0,0,0-.867.867V8.46a.867.867,0,0,0,.867.867H8.46a.867.867,0,0,0,.867-.867V4.124a.867.867,0,0,0-.869-.867Z"
				transform="translate(58.715 507.01)"
				fill="none"
				stroke="#727994"
				stroke-width="1"
			/>
			<path
				id="Path_19918"
				data-name="Path 19918"
				d="M20.4,3.256H16.062a.867.867,0,0,0-.867.867V8.46a.867.867,0,0,0,.867.867H20.4a.867.867,0,0,0,.867-.867V4.124a.867.867,0,0,0-.867-.867Z"
				transform="translate(55.788 507.01)"
				fill="none"
				stroke="#727994"
				stroke-width="1"
			/>
			<path
				id="Path_19919"
				data-name="Path 19919"
				d="M8.458,15.2H4.124a.867.867,0,0,0-.867.867V20.4a.867.867,0,0,0,.867.867H8.46a.867.867,0,0,0,.867-.867V16.064a.867.867,0,0,0-.869-.867Z"
				transform="translate(58.715 504.085)"
				fill="none"
				stroke="#727994"
				stroke-width="1"
			/>
			<path
				id="Path_19920"
				data-name="Path 19920"
				d="M20.4,15.2H16.062a.867.867,0,0,0-.867.867V20.4a.867.867,0,0,0,.867.867H20.4a.867.867,0,0,0,.867-.867V16.064A.867.867,0,0,0,20.4,15.2Z"
				transform="translate(55.788 504.085)"
				fill="none"
				stroke="#727994"
				stroke-width="1"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ModulesSVG',
};
</script>
